import { useAppDispatch, useAppStore } from '../../../../app/hooks';
import { useProposalDrawer } from '../../../proposals/ProposalDrawer';
import { actions as boardActions, selectBoard } from '../../../../slices/boardSlice';
import { selectContactsMap } from 'slices/contactsSlice';
import { makeSelectProposalsByContact, updateProposal } from 'slices/proposalsSlice';
import { hideCallsBatch } from 'slices/callsSlice';
import { withErrorSnackbar } from 'src/services/api/withErrorSnackbar';
import { useSnackbar } from 'notistack';

function useCreateProposalFromBoardItem(type: string) {
  const { openCreateForm, close } = useProposalDrawer();
  const dispatch = useAppDispatch();
  const store = useAppStore();
  const { enqueueSnackbar } = useSnackbar();

  return (itemUuid: string, colUuid: string) => {
    const board = selectBoard(store.getState());
    const item = board.columns
      .find((colItem) => colItem.id === colUuid)
      ?.items.find((item) => item.uuid === itemUuid);

    if (!item) {
      return;
    }

    const selectProposalsByContact = makeSelectProposalsByContact();
    const relatedProposals = selectProposalsByContact(store.getState(), item.typeUuid);
    const hasRelatedProposals = relatedProposals.length > 0;

    const handleMoveToQuote = () => {
      withErrorSnackbar({
        onTry: async () => {
          const proposalToShow =
            relatedProposals.find(({ visible }) => !visible) || relatedProposals[0];

          if (proposalToShow && !proposalToShow.visible) {
            await dispatch(
              updateProposal({
                ...proposalToShow,
                visible: true,
                updatedAt: Date.now(),
              })
            ).unwrap();
          }

          const contactsMap = selectContactsMap(store.getState());
          const contact = contactsMap[item.typeUuid];
          const contactPhones = contact.phones.map(({ normalized_phone }) => normalized_phone);
          dispatch(hideCallsBatch(contactPhones));

          dispatch(
            boardActions.deleteItems({
              columnUuid: colUuid,
              itemsUuids: [itemUuid],
            })
          );
          close();
        },
        enqueueSnackbar,
      });
    };

    if (hasRelatedProposals) {
      handleMoveToQuote();
      return;
    }

    openCreateForm({
      defaultValues: { contactId: item.typeUuid },
      onSuccess: handleMoveToQuote,
      shouldPinContact: true,
      type,
    });
  };
}

export default useCreateProposalFromBoardItem;
